/* istanbul ignore file */
import { defineMessages } from 'react-intl';

export const serviceItemsMessages = defineMessages({
  chipLabel: { id: 'atblayer.chipLabel', defaultMessage: 'TIPP' },
  serviceItemsHeadline: {
    id: 'atblayer.serviceitems.card.headline',
    defaultMessage: 'Einfach mitbestellen',
  },
  serviceItemsMoreInfo: {
    id: 'atblayer.serviceitems.more.text',
    defaultMessage: 'Mehr Infos',
  },
  serviceItemsInclusive: {
    id: 'atblayer.serviceitems.inclusive',
    defaultMessage: 'Inklusive',
  },
  serviceItemsErrorMessage: {
    id: 'atblayer.serviceitems.error.message',
    defaultMessage: 'Änderung konnte nicht gespeichert werden',
  },
});
